var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"sctFooter\">\n<a href=\"http://www.travelctm.com\" target=\"_blank\" class=\"sctFooter_logo\"></a>\n<div class=\"sctFooter_textLinks\">\n<a href=\"http://www.travelctm.com/global-privacy-policy\" target=\"_blank\">Privacy Policy</a> | <a ui-sref=\"terms\" target=\"_blank\">Terms of Use</a> | <a ui-sref=\"app.user.support\">Customer Support</a>\n</div>\n<div class=\"sctFooter_socialLinks\">\n<a href=\"https://www.facebook.com/corporatetravelmanagementANZ\" target=\"_blank\" class=\"sctFooter_socialLink facebook\">Facebook</a>\n<a href=\"https://twitter.com/TravelCTM\" target=\"_blank\" class=\"sctFooter_socialLink twitter\">Twitter</a>\n<a href=\"https://www.linkedin.com/company/corporate-travel-management\" target=\"_blank\" class=\"sctFooter_socialLink linkedIn\">Facebook</a>\n</div>\n</div>\n";
var id1="sct/sctFooter/sctFooter.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/sct/sctFooter/sctFooter.html
// module id = 1282
// module chunks = 1